import {gemStore} from 'app/gemStore';
import type {NewState, ComponentUrlState} from 'app/utils/urlStateElements/interfaces';

export const historyChangeAction = (hashPath: string, queryPath: string) => gemStore.getState().historyChange({hashPath, queryPath});

export const setParsedURLStateAction = (hashState: NewState, queryState: ComponentUrlState) => gemStore.getState().setParsedURLState({hashState, queryState});
